//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const FALLOUT_API_BASE_URL = new InjectionToken<string>('FALLOUT_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class FalloutFunctionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(FALLOUT_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFalloutError(id?: number | undefined): Observable<EventDetailResponse> {
        let url_ = this.baseUrl + "/api/fallout/get/event?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFalloutError(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFalloutError(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EventDetailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EventDetailResponse>;
        }));
    }

    protected processGetFalloutError(response: HttpResponseBase): Observable<EventDetailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventDetailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllIntegrationCategories(): Observable<IntegrationDetailResponse> {
        let url_ = this.baseUrl + "/api/fallout/get/integration-categories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllIntegrationCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllIntegrationCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegrationDetailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegrationDetailResponse>;
        }));
    }

    protected processGetAllIntegrationCategories(response: HttpResponseBase): Observable<IntegrationDetailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntegrationDetailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllIntegrationJobStatuses(): Observable<IntegrationDetailResponse> {
        let url_ = this.baseUrl + "/api/fallout/get/integration-job-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllIntegrationJobStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllIntegrationJobStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegrationDetailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegrationDetailResponse>;
        }));
    }

    protected processGetAllIntegrationJobStatuses(response: HttpResponseBase): Observable<IntegrationDetailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntegrationDetailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllIntegrationJobs(): Observable<IntegrationDetailResponse> {
        let url_ = this.baseUrl + "/api/fallout/get/integration-jobs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllIntegrationJobs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllIntegrationJobs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegrationDetailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegrationDetailResponse>;
        }));
    }

    protected processGetAllIntegrationJobs(response: HttpResponseBase): Observable<IntegrationDetailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntegrationDetailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getJobLogsDetails(): Observable<JobLogsDetailsResponse> {
        let url_ = this.baseUrl + "/api/fallout/get/job-log-details";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobLogsDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobLogsDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobLogsDetailsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobLogsDetailsResponse>;
        }));
    }

    protected processGetJobLogsDetails(response: HttpResponseBase): Observable<JobLogsDetailsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobLogsDetailsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getJobLogsDetailsbyCode(body?: JobLogsDetailsByCodeRequest | undefined): Observable<JobLogsDetailsResponse> {
        let url_ = this.baseUrl + "/api/fallout/get/job-log-details-by-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobLogsDetailsbyCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobLogsDetailsbyCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobLogsDetailsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobLogsDetailsResponse>;
        }));
    }

    protected processGetJobLogsDetailsbyCode(response: HttpResponseBase): Observable<JobLogsDetailsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobLogsDetailsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllLogTypes(): Observable<IdTextResponse[]> {
        let url_ = this.baseUrl + "/api/fallout/logtypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLogTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLogTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdTextResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdTextResponse[]>;
        }));
    }

    protected processGetAllLogTypes(response: HttpResponseBase): Observable<IdTextResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IdTextResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resolveFalloutErrors(body?: number[] | undefined): Observable<IsSuccessResponse> {
        let url_ = this.baseUrl + "/api/fallout/resolve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveFalloutErrors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveFalloutErrors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsSuccessResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsSuccessResponse>;
        }));
    }

    protected processResolveFalloutErrors(response: HttpResponseBase): Observable<IsSuccessResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsSuccessResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchFalloutErrorDetails(body?: SearchEventDetailRequest | undefined): Observable<SearchEventDetailsResponse> {
        let url_ = this.baseUrl + "/api/fallout/search/event-details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchFalloutErrorDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchFalloutErrorDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchEventDetailsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchEventDetailsResponse>;
        }));
    }

    protected processSearchFalloutErrorDetails(response: HttpResponseBase): Observable<SearchEventDetailsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchEventDetailsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchFalloutErrorSummaries(body?: SearchEventSummaryRequest | undefined): Observable<SearchEventSummariesResponse> {
        let url_ = this.baseUrl + "/api/fallout/search/event-summaries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchFalloutErrorSummaries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchFalloutErrorSummaries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchEventSummariesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchEventSummariesResponse>;
        }));
    }

    protected processSearchFalloutErrorSummaries(response: HttpResponseBase): Observable<SearchEventSummariesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchEventSummariesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllSources(): Observable<IdTextResponse[]> {
        let url_ = this.baseUrl + "/api/fallout/sources";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSources(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSources(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdTextResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdTextResponse[]>;
        }));
    }

    protected processGetAllSources(response: HttpResponseBase): Observable<IdTextResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IdTextResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    update(): Observable<UpdateIntegrationLogResponse> {
        let url_ = this.baseUrl + "/api/integrationlog/update";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateIntegrationLogResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateIntegrationLogResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateIntegrationLogResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateIntegrationLogResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    ping(): Observable<void> {
        let url_ = this.baseUrl + "/api/Ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class EventDetailResponse implements IEventDetailResponse {
    errorMessage?: string | undefined;
    readonly isError?: boolean;
    id?: number;
    eventDate?: Date;
    category?: string | undefined;
    errorDescription?: string | undefined;
    logType?: string | undefined;
    source?: string | undefined;
    subcategory?: string | undefined;
    job?: string | undefined;
    isResolved?: boolean | undefined;
    dateResolved?: Date | undefined;
    messageBody?: string | undefined;
    jobLogToken?: string | undefined;

    constructor(data?: IEventDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            (<any>this).isError = _data["isError"];
            this.id = _data["id"];
            this.eventDate = _data["eventDate"] ? new Date(_data["eventDate"].toString()) : <any>undefined;
            this.category = _data["category"];
            this.errorDescription = _data["errorDescription"];
            this.logType = _data["logType"];
            this.source = _data["source"];
            this.subcategory = _data["subcategory"];
            this.job = _data["job"];
            this.isResolved = _data["isResolved"];
            this.dateResolved = _data["dateResolved"] ? new Date(_data["dateResolved"].toString()) : <any>undefined;
            this.messageBody = _data["messageBody"];
            this.jobLogToken = _data["jobLogToken"];
        }
    }

    static fromJS(data: any): EventDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EventDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["id"] = this.id;
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : <any>undefined;
        data["category"] = this.category;
        data["errorDescription"] = this.errorDescription;
        data["logType"] = this.logType;
        data["source"] = this.source;
        data["subcategory"] = this.subcategory;
        data["job"] = this.job;
        data["isResolved"] = this.isResolved;
        data["dateResolved"] = this.dateResolved ? this.dateResolved.toISOString() : <any>undefined;
        data["messageBody"] = this.messageBody;
        data["jobLogToken"] = this.jobLogToken;
        return data;
    }
}

export interface IEventDetailResponse {
    errorMessage?: string | undefined;
    isError?: boolean;
    id?: number;
    eventDate?: Date;
    category?: string | undefined;
    errorDescription?: string | undefined;
    logType?: string | undefined;
    source?: string | undefined;
    subcategory?: string | undefined;
    job?: string | undefined;
    isResolved?: boolean | undefined;
    dateResolved?: Date | undefined;
    messageBody?: string | undefined;
    jobLogToken?: string | undefined;
}

export class IdTextResponse implements IIdTextResponse {
    errorMessage?: string | undefined;
    readonly isError?: boolean;
    id?: number;
    displayText?: string | undefined;

    constructor(data?: IIdTextResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            (<any>this).isError = _data["isError"];
            this.id = _data["id"];
            this.displayText = _data["displayText"];
        }
    }

    static fromJS(data: any): IdTextResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IdTextResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["id"] = this.id;
        data["displayText"] = this.displayText;
        return data;
    }
}

export interface IIdTextResponse {
    errorMessage?: string | undefined;
    isError?: boolean;
    id?: number;
    displayText?: string | undefined;
}

export class IntegrationDetail implements IIntegrationDetail {
    id?: number;
    code?: string | undefined;
    displayText?: string | undefined;

    constructor(data?: IIntegrationDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.displayText = _data["displayText"];
        }
    }

    static fromJS(data: any): IntegrationDetail {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["displayText"] = this.displayText;
        return data;
    }
}

export interface IIntegrationDetail {
    id?: number;
    code?: string | undefined;
    displayText?: string | undefined;
}

export class IntegrationDetailResponse implements IIntegrationDetailResponse {
    errorMessage?: string | undefined;
    readonly isError?: boolean;
    integrationDetails?: IntegrationDetail[] | undefined;

    constructor(data?: IIntegrationDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            (<any>this).isError = _data["isError"];
            if (Array.isArray(_data["integrationDetails"])) {
                this.integrationDetails = [] as any;
                for (let item of _data["integrationDetails"])
                    this.integrationDetails!.push(IntegrationDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IntegrationDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        if (Array.isArray(this.integrationDetails)) {
            data["integrationDetails"] = [];
            for (let item of this.integrationDetails)
                data["integrationDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIntegrationDetailResponse {
    errorMessage?: string | undefined;
    isError?: boolean;
    integrationDetails?: IntegrationDetail[] | undefined;
}

export class IsSuccessResponse implements IIsSuccessResponse {
    errorMessage?: string | undefined;
    readonly isError?: boolean;
    isSuccess?: boolean;

    constructor(data?: IIsSuccessResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            (<any>this).isError = _data["isError"];
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): IsSuccessResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IsSuccessResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface IIsSuccessResponse {
    errorMessage?: string | undefined;
    isError?: boolean;
    isSuccess?: boolean;
}

export class JobLogsDetailsByCodeRequest implements IJobLogsDetailsByCodeRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    jobCodes?: string[] | undefined;
    statuses?: string[] | undefined;
    categories?: string[] | undefined;

    constructor(data?: IJobLogsDetailsByCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            if (Array.isArray(_data["jobCodes"])) {
                this.jobCodes = [] as any;
                for (let item of _data["jobCodes"])
                    this.jobCodes!.push(item);
            }
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(item);
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(item);
            }
        }
    }

    static fromJS(data: any): JobLogsDetailsByCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new JobLogsDetailsByCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        if (Array.isArray(this.jobCodes)) {
            data["jobCodes"] = [];
            for (let item of this.jobCodes)
                data["jobCodes"].push(item);
        }
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item);
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        return data;
    }
}

export interface IJobLogsDetailsByCodeRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    jobCodes?: string[] | undefined;
    statuses?: string[] | undefined;
    categories?: string[] | undefined;
}

export class JobLogsDetailsDto implements IJobLogsDetailsDto {
    code?: string | undefined;
    category?: string | undefined;
    displayText?: string | undefined;
    token?: string | undefined;
    isScheduled?: boolean | undefined;
    startDateTime?: Date | undefined;
    endDateTime?: Date | undefined;
    totalRequestCount?: number | undefined;
    retry?: number | undefined;
    lastRunStatus?: string | undefined;
    lastRunSubStatus?: string | undefined;
    validationCount?: number | undefined;
    systemErrorCount?: number | undefined;
    logTypeId?: number | undefined;
    sourceId?: number | undefined;
    integrationJobLogId?: number | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;

    constructor(data?: IJobLogsDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.category = _data["category"];
            this.displayText = _data["displayText"];
            this.token = _data["token"];
            this.isScheduled = _data["isScheduled"];
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : <any>undefined;
            this.totalRequestCount = _data["totalRequestCount"];
            this.retry = _data["retry"];
            this.lastRunStatus = _data["lastRunStatus"];
            this.lastRunSubStatus = _data["lastRunSubStatus"];
            this.validationCount = _data["validationCount"];
            this.systemErrorCount = _data["systemErrorCount"];
            this.logTypeId = _data["logTypeId"];
            this.sourceId = _data["sourceId"];
            this.integrationJobLogId = _data["integrationJobLogId"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): JobLogsDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobLogsDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["category"] = this.category;
        data["displayText"] = this.displayText;
        data["token"] = this.token;
        data["isScheduled"] = this.isScheduled;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
        data["totalRequestCount"] = this.totalRequestCount;
        data["retry"] = this.retry;
        data["lastRunStatus"] = this.lastRunStatus;
        data["lastRunSubStatus"] = this.lastRunSubStatus;
        data["validationCount"] = this.validationCount;
        data["systemErrorCount"] = this.systemErrorCount;
        data["logTypeId"] = this.logTypeId;
        data["sourceId"] = this.sourceId;
        data["integrationJobLogId"] = this.integrationJobLogId;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IJobLogsDetailsDto {
    code?: string | undefined;
    category?: string | undefined;
    displayText?: string | undefined;
    token?: string | undefined;
    isScheduled?: boolean | undefined;
    startDateTime?: Date | undefined;
    endDateTime?: Date | undefined;
    totalRequestCount?: number | undefined;
    retry?: number | undefined;
    lastRunStatus?: string | undefined;
    lastRunSubStatus?: string | undefined;
    validationCount?: number | undefined;
    systemErrorCount?: number | undefined;
    logTypeId?: number | undefined;
    sourceId?: number | undefined;
    integrationJobLogId?: number | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
}

export class JobLogsDetailsResponse implements IJobLogsDetailsResponse {
    errorMessage?: string | undefined;
    readonly isError?: boolean;
    jobLogDetails?: JobLogsDetailsDto[] | undefined;
    count?: number;

    constructor(data?: IJobLogsDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            (<any>this).isError = _data["isError"];
            if (Array.isArray(_data["jobLogDetails"])) {
                this.jobLogDetails = [] as any;
                for (let item of _data["jobLogDetails"])
                    this.jobLogDetails!.push(JobLogsDetailsDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): JobLogsDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new JobLogsDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        if (Array.isArray(this.jobLogDetails)) {
            data["jobLogDetails"] = [];
            for (let item of this.jobLogDetails)
                data["jobLogDetails"].push(item.toJSON());
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IJobLogsDetailsResponse {
    errorMessage?: string | undefined;
    isError?: boolean;
    jobLogDetails?: JobLogsDetailsDto[] | undefined;
    count?: number;
}

export class SearchEventDetailRequest implements ISearchEventDetailRequest {
    companyCode!: string;
    sourceId?: number | undefined;
    logTypeId?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    includeResolved?: boolean | undefined;
    pageNum?: number | undefined;
    pageSize?: number | undefined;
    sortCol?: string | undefined;
    sortDir?: string | undefined;
    jobLogToken?: string | undefined;

    constructor(data?: ISearchEventDetailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.sourceId = _data["sourceId"];
            this.logTypeId = _data["logTypeId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.includeResolved = _data["includeResolved"];
            this.pageNum = _data["pageNum"];
            this.pageSize = _data["pageSize"];
            this.sortCol = _data["sortCol"];
            this.sortDir = _data["sortDir"];
            this.jobLogToken = _data["jobLogToken"];
        }
    }

    static fromJS(data: any): SearchEventDetailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchEventDetailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["sourceId"] = this.sourceId;
        data["logTypeId"] = this.logTypeId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["includeResolved"] = this.includeResolved;
        data["pageNum"] = this.pageNum;
        data["pageSize"] = this.pageSize;
        data["sortCol"] = this.sortCol;
        data["sortDir"] = this.sortDir;
        data["jobLogToken"] = this.jobLogToken;
        return data;
    }
}

export interface ISearchEventDetailRequest {
    companyCode: string;
    sourceId?: number | undefined;
    logTypeId?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    includeResolved?: boolean | undefined;
    pageNum?: number | undefined;
    pageSize?: number | undefined;
    sortCol?: string | undefined;
    sortDir?: string | undefined;
    jobLogToken?: string | undefined;
}

export class SearchEventDetailsResponse implements ISearchEventDetailsResponse {
    errorMessage?: string | undefined;
    readonly isError?: boolean;
    items?: EventDetailResponse[] | undefined;
    totalRecordCount?: number;

    constructor(data?: ISearchEventDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            (<any>this).isError = _data["isError"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EventDetailResponse.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
        }
    }

    static fromJS(data: any): SearchEventDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchEventDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        return data;
    }
}

export interface ISearchEventDetailsResponse {
    errorMessage?: string | undefined;
    isError?: boolean;
    items?: EventDetailResponse[] | undefined;
    totalRecordCount?: number;
}

export class SearchEventSummariesResponse implements ISearchEventSummariesResponse {
    errorMessage?: string | undefined;
    readonly isError?: boolean;
    items?: SearchEventSummaryResponse[] | undefined;
    totalRecordCount?: number;

    constructor(data?: ISearchEventSummariesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            (<any>this).isError = _data["isError"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SearchEventSummaryResponse.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
        }
    }

    static fromJS(data: any): SearchEventSummariesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchEventSummariesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecordCount"] = this.totalRecordCount;
        return data;
    }
}

export interface ISearchEventSummariesResponse {
    errorMessage?: string | undefined;
    isError?: boolean;
    items?: SearchEventSummaryResponse[] | undefined;
    totalRecordCount?: number;
}

export class SearchEventSummaryRequest implements ISearchEventSummaryRequest {
    companyCode!: string;
    sourceId?: number | undefined;
    logTypeId?: number | undefined;
    includeResolved?: boolean | undefined;
    pageNum?: number | undefined;
    pageSize?: number | undefined;
    sortCol?: string | undefined;
    sortDir?: string | undefined;

    constructor(data?: ISearchEventSummaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            this.sourceId = _data["sourceId"];
            this.logTypeId = _data["logTypeId"];
            this.includeResolved = _data["includeResolved"];
            this.pageNum = _data["pageNum"];
            this.pageSize = _data["pageSize"];
            this.sortCol = _data["sortCol"];
            this.sortDir = _data["sortDir"];
        }
    }

    static fromJS(data: any): SearchEventSummaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchEventSummaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        data["sourceId"] = this.sourceId;
        data["logTypeId"] = this.logTypeId;
        data["includeResolved"] = this.includeResolved;
        data["pageNum"] = this.pageNum;
        data["pageSize"] = this.pageSize;
        data["sortCol"] = this.sortCol;
        data["sortDir"] = this.sortDir;
        return data;
    }
}

export interface ISearchEventSummaryRequest {
    companyCode: string;
    sourceId?: number | undefined;
    logTypeId?: number | undefined;
    includeResolved?: boolean | undefined;
    pageNum?: number | undefined;
    pageSize?: number | undefined;
    sortCol?: string | undefined;
    sortDir?: string | undefined;
}

export class SearchEventSummaryResponse implements ISearchEventSummaryResponse {
    errorMessage?: string | undefined;
    readonly isError?: boolean;
    sourceId?: number;
    sourceDisplay?: string | undefined;
    logTypeId?: number;
    logTypeDisplay?: string | undefined;
    errorCount?: number;

    constructor(data?: ISearchEventSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            (<any>this).isError = _data["isError"];
            this.sourceId = _data["sourceId"];
            this.sourceDisplay = _data["sourceDisplay"];
            this.logTypeId = _data["logTypeId"];
            this.logTypeDisplay = _data["logTypeDisplay"];
            this.errorCount = _data["errorCount"];
        }
    }

    static fromJS(data: any): SearchEventSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchEventSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["sourceId"] = this.sourceId;
        data["sourceDisplay"] = this.sourceDisplay;
        data["logTypeId"] = this.logTypeId;
        data["logTypeDisplay"] = this.logTypeDisplay;
        data["errorCount"] = this.errorCount;
        return data;
    }
}

export interface ISearchEventSummaryResponse {
    errorMessage?: string | undefined;
    isError?: boolean;
    sourceId?: number;
    sourceDisplay?: string | undefined;
    logTypeId?: number;
    logTypeDisplay?: string | undefined;
    errorCount?: number;
}

export class UpdateIntegrationLogResponse implements IUpdateIntegrationLogResponse {
    errorMessage?: string | undefined;
    readonly isError?: boolean;
    integrationLogId?: number;
    resolvedOn?: Date;

    constructor(data?: IUpdateIntegrationLogResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            (<any>this).isError = _data["isError"];
            this.integrationLogId = _data["integrationLogId"];
            this.resolvedOn = _data["resolvedOn"] ? new Date(_data["resolvedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateIntegrationLogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIntegrationLogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["isError"] = this.isError;
        data["integrationLogId"] = this.integrationLogId;
        data["resolvedOn"] = this.resolvedOn ? this.resolvedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateIntegrationLogResponse {
    errorMessage?: string | undefined;
    isError?: boolean;
    integrationLogId?: number;
    resolvedOn?: Date;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}